import {
    Page,
    Layout,
    Card,
    PageActions,
    SkeletonBodyText,
    Banner
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../../common/Helpers';
import ShowTagGroupErrorsModal from '../../../components/ShowTagGroupErrorsModal';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';

class SmartCollectionProductTagsValidationRuleViewPage extends Component {

    constructor(props) {
        super(props)

        const { params } = this.props.match;

        this.state = {
            loading: true,
            executingRule: false,
            id: params.id,
            errors: [],
            rule: null,
            executions: []
        };
    }

    render() {

        if (this.state.loading)
            return <SkeletonBodyText lines="20" />;

        var hasErrors = this.state.errors.length > 0;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Validation Rule</title>
                </Helmet>
                <Page
                    title={"Validation Rule: " + this.state.rule.name}
                    secondaryActions={[{ content: 'Edit', onAction: this.handleEdit }]}
                    breadcrumbs={[{ content: 'Validation Rules', url: '/validation-rules' }]}
                >
                    <Layout fullWidth>
                        <ShowTagGroupErrorsModal
                            active={this.state.showingErrors}
                            errors={this.state.errors}
                            onDismiss={this.toggleErrorsModal} />
                        {hasErrors && <Layout.Section>
                            <Banner
                                title="Validation rule errors"
                                status="critical"
                                onDismiss={null}
                                action={{ content: "Show errors", onAction: this.showErrors }}
                            >
                                <p>This group has resources failing its validation rules. Click to see which resources are failing and why.</p>
                            </Banner>
                        </Layout.Section>
                        }
                        <Layout.Section>
                            <Card>
                                <Card.Section title="Name">
                                    {this.state.rule.name}
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        secondaryActions={[
                            {
                                content: 'Delete rule',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>
            </div>
        );
    }

    showErrors = () => {
        this.toggleErrorsModal();
    }

    toggleErrorsModal = () => {
        this.setState({
            showingErrors: !this.state.showingErrors
        });
    }


    handleDelete = () => {

        fetch(`api/validationRules/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/validation-rules");
        });
    }

    handleEdit = () => {
        this.props.history.push(`/validation-rules/edit/${this.state.rule.type}/${this.state.rule.id}`);
    }

    fetchRuleData = () => {
        fetch(`api/validationRules/SmartCollectionProductTagsValidation/${this.state.id}`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => this.setState({
                rule: data,
                loading: false
            }));
    }

    fetchExecutions = () => {

        fetch(`api/validationRules/${this.state.id}/executions`, {
            method: 'get'
        })
            .then(response => response.json())
            .then(data => this.setState({
                executions: data,
                loadingExecutions: false
            }));
    }

    fetchErrorsData = () => {
        fetch(`api/validationRules/${this.state.id}/errors`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                errors: data,
            }));
    }

    componentDidMount() {
        this.fetchRuleData();
        this.fetchErrorsData();
    }
}

export default SmartCollectionProductTagsValidationRuleViewPage